import CoreButton from '@shared/components/core/button/CoreButton';
import CardIcon from '@shared/components/core/card/CardIcon';
import ActivateLicenseDialog from '@shared/components/license/ActivateLicenseDialog';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import OrgLinks from '../OrgLinks';

interface IOrgSubscriptionCardProps {
    orgId: string;
    isLicensed: boolean;
}

// refactor this if using billing page
// this card will reroute to BillingRedirectPage since it loads the payment link and opens it in a new tab
export default function OrgBillingCard({ orgId, isLicensed }: IOrgSubscriptionCardProps) {
    const { t } = useTranslation();
    const [showDialog, setShowDialog] = useState(false);

    const onClick = () => {
        setShowDialog(true);
    };

    const onCancel = () => {
        setShowDialog(false);
    };

    if (!orgId) return null;
    return (
        <CardIcon name="money" title={t('common:billing.title')} description={t('common:billing.description')}>
            {isLicensed ? (
                <OrgLinks organizationId={orgId} variant="orgBillingRedirect" />
            ) : (
                <>
                    <OrgLinks organizationId={orgId} variant="orgTrialBillingRedirect" />
                    <CoreButton $color="subsection" onClick={onClick}>
                        {t('common:license.activate.title')}
                    </CoreButton>
                    <ActivateLicenseDialog open={showDialog} onCancel={onCancel} organizationId={orgId} />
                </>
            )}
        </CardIcon>
    );
}
